/* eslint-disable no-irregular-whitespace */
import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../layouts/layout';
import { Banner, Grid, PageSection, Row, Col, Avatar } from '../components';

import cennikImg from '../assets/img/cennik.jpg';
import cennik from '../assets/illustrations/cennik.svg';
import { getAge } from '../helpers/numbers';

const CreativeMovementStudioPage = ({ data }) => {
  const { lektori } = data;

  function getLector(lectorName) {
    return lektori.edges.filter(({ node: { name } }) => name === lectorName)[0]
      .node;
  }

  return (
    <Layout type="transparent">
      <Helmet title={`Adrian Bartalos | Creative Movement Studio`}>
        <meta property="og:image" content={cennikImg} />
        <meta
          property="og:title"
          content={`Adrian Bartalos | Creative Movement Studio`}
        />
      </Helmet>
      <Banner bgUrl={cennikImg} fullWidth overlay fitContent="s">
        <h1 className="text-color-white text-center">
          Creative Movement Studio
        </h1>
      </Banner>
      <PageSection type="beige" className="pb-xxsmall">
        <Grid>
          <Row>
            <Col xs={12}>
              <p>
                <span className="text-color-brick">
                  <strong>
                    Malé kreatívne štúdio s veľkým srdcom a rodinnou atmosférou.
                  </strong>
                </span>{' '}
                Naším cieľom je, aby sa stalo domovom pre všetkých nadšencov
                rôznorodého pohybu. Nájdete u nás naozaj pestrú ponuku hodín,
                vďaka ktorým môžete zabudnúť na každodenné povinnosti, zároveň
                rozvíjať Vaše pohybové schopnosti a dopriať si relax aj zábavu.
                Záležať sme si dali aj pri výbere našich lektorov, ktorí sú
                zárukou kvality a profesionálneho prístupu.
              </p>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1">Floorwork a soft acrobatics</h3>
              <h4 className="h2">Skupinové hodiny</h4>
              <p>
                Pohyb je ako ľudská reč. Deti začínajú jednoduchými hláskami,
                ktoré sa po niekoľkých rokoch menia na rozvité súvetia. Podobným
                procesom prechádzate aj v oblasti floorworku a ľahkej akrobacie.
                Cieľom hodiny je harmonický rozvoj, rozšírenie pohybovej zásoby
                a posun začiatočníka na pokročilého zakaždým v inej sfére.
                Pestrá náplň hodín sa systematicky mení v závislosti od danej
                témy. Vhodné pre všetky fyzické a vekové úrovne.
              </p>

              <h4 className="h2">Individuálne hodiny</h4>
              <p className="mb-xlarge">
                Objavte umenie telesného rozvoja podľa vašich predstáv. Súkromné
                hodiny sú skvelá voľba pri zameraní na vami zvolený typ tréningu
                a naplnení osobných cieľov. Trénujúci sa učí hýbať novými
                spôsobmi a zároveň prekonáva stále vačšie výzvy. Samotný proces
                rozvíja mentálnu stránku a buduje komplexnosť tela.
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-adrian').childImageSharp.fixed
                          .src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-adrian').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Adrián"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic">
                    „Mám {getAge('1993')} rokov. Od detsva je rôznorodý pohyb
                    neoddeliteľnou súčasťou môjho života, no všetko začalo
                    futbalom, čo mi prinieslo možnosť študovať na univerzite v
                    USA. Vďaka novým skúsenostiam, cestovaniu a spoznávaniu
                    ďaľsích svetových kultúr som stretol mnoho učiteľov, ktorí
                    mi ponúkli nový pohľad na ľudské telo a pohyb. Som
                    zakladateľom Creative Movement Studio a taktiež sa venujem
                    profesionálnym vystúpeniam v oblasti výškovej akrobacie.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1">Latino Ladies</h3>
              <p className="mb-xlarge">
                Latino ladies je pre všetky dámy, ženy a slečny, ktoré sa chcú
                odreagovať a oddýchnuť si v kruhu žien. Naučíte sa základy
                latinsko-amerických tancov. Choreografie sú prispôsobené tak,
                aby si dámy mohli zatancovať bez partnera. Zostavy krásne
                formujú postavu a kedže sa jedná o dynamickejšie tréningy,
                napomáhaju pri spaľovaní tukov. Budete sa cítiť sebavedomo a
                žensky.
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-dominika').childImageSharp.fixed
                          .src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-dominika').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Dominika"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic">
                    „Mám {getAge('1995')} rokov. Od svojich 7 rokov sa venujem
                    spoločenským tancom na profesionálnej úrovni. Som
                    štvornásobnou majsterkou a trojnásobnou vicemajsterkou
                    Slovenska v štandardných aj latinskoamerických tancoch v
                    kategórii junior a mládež. Som absolventkou Vysokej školy
                    múzických umení, kde som študovala odbor tanečné umenie –
                    moderný tanec. V poslednej sérií najpopulárnejšej tanečnej
                    show Let’s Dance na Slovensku som tvorila tanečný pár s
                    hercom Vladimírom Kobielskym, s ktorým sme získali titul
                    kráľ a kráľovná tanečného parketu.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1">Kreatívne herničky</h3>
              <p>
                Kreatívne herničky predstavujú podnetný priestor pre deti, ale
                aj ich rodičov, ktorí objavujú úžasný a prirodzený svet svojich
                detí ich očami a rukami. Herničky prinášajú deťom kreatívne
                objavovanie sveta okolo nich spôsobom, ktorý rešpektuje ich
                vlastné tempo a jednotlivé senzitívne a vývinové obdobia. Cieľom
                herničiek je rozvíjať osobnosť detí, ich samostatnosť,
                nezávislosť, schopnosť rozhodovať sa, ale hlavne sebadôveru a
                lásku k sebe a k svojmu okoliu.
              </p>
              <p className="mb-xlarge">
                Deti si voľne vyberajú činnosť, ktorú chcú vykonávať a tiež
                pomôcku, s ktorou chcú pracovať. Jednotlivé aktivity sú
                pripravené tak, aby rešpektovali senzitívne obdobia detského
                veku. Aktivity sú zamerané na to, aby deti pri spoznávaní sveta
                porozumeli tomu, čo vidia a čo ich obklopuje, a aby rozvíjali
                svoje zručnosti vlasntým tempom.
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-anka').childImageSharp.fixed.src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-anka').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Anka"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic mb">
                    „Mám {getAge('1993')} rokov a od detstva mám srdce pre deti,
                    možno aj preto, že pochádzam z deviatich detí. Počas štúdia
                    na ŠÚV v Bratislave som sa venovala dobrovoľníckej činnosti
                    v rámci neziskovej organizácie Úsmev ako dar. Popri štúdiu
                    Odevného dizajnu na VŠVU v Bratislave som študovala
                    pedagogické minimum zamerané na Výtvarnú výchovu. Už počas
                    vysokej školy som pôsobila ako animátorka na viacerých
                    táboroch, ale aj v iných akciách pre deti. V súčastnosti
                    pracujem už niekoľko rokov ako opatrovateľka vo viacerých
                    rodinách a zároveň som učiteľkou v Montessori škôločke.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1">Spoločenské tance</h3>
              <h4 className="h2">Individuálne hodiny PRO-AM </h4>
              <p>
                Hodiny tanca s profesionálnymi tanečníkmi podľa svetového
                konceptu PROAM sú pre všetkých, ktorí túžia tancovať vo dvojici,
                no chýba im partner. Individuálny prístup lektora umožňuje
                rýchlejšie napredovanie, a taktiež dodáva dávku sebavedomia a
                istoty, čo ocenia najmä začínajúci tanečníci. Ak máte ambície
                vypracovať sa vyššie, môžete v tejto disciplíne súťažiť na
                najslávnejšom Blackpool Dance Festivale. Pre zaujímavosť na
                základe tohto konceptu vznikla aj svetoznáma TV show “Dancing
                with the stars”, u nás známa pod názvom “Let´s Dance”.
              </p>

              <h4 className="h2">Skupinové kurzy</h4>
              <p className="mb-xlarge">
                Hovorí sa, že partner je naším zrkadlom. V pohybe a spoločenskom
                tanci to platí dvojnásobne. Ak sa chcete o sebe dozvedieť viac,
                zlepšiť komunikáciu, naučiť sa lepšie počúvať a reagovať,
                partnering v spoločenskom tanci je jedným z najlepších
                nástrojov. Tanec s partnerom opačného pohlavia si vyžaduje
                oceňovanie odlišného vnímania a vnútorného sveta partnera, čím
                dokážeme nadobudnúť dokonalú harmóniu v pohybe, ktorá prináša
                balans aj do bežného života.”
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-mate').childImageSharp.fixed.src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-mate').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Maté"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic mb">
                    „Mám {getAge('1998')} rokov, od svojich 6 rokov sa venujem
                    spoločenským tancom. Som viacnásobným vicemajstrom Slovenska
                    a Maďarska v kategorii mládež do 21 rokov. Taktiež som sa
                    niekoľko krát zúčastnil Majstrovstiev sveta v
                    latinsko-amerických tancoch ako reprezentant Maďarska. Okrem
                    Európy a Ázie som mal možnosť tancovať na tanečných show v
                    Kanade, Philadelphii, Washington DC, New Yorku, či na
                    Floride. Momentálne študujem na Hungarian Dance Academy v
                    Budapešti, popritom sa profesionálne venujem
                    latinsko-americkým tancom a spolu s mojou tanečnou
                    partnerkou Dominikou Roškovou reprezentujeme Slovenskú
                    republiku.”
                  </p>
                </Col>
              </Row>
              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-dominika-druha').childImageSharp
                          .fixed.src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-dominika-druha').childImageSharp
                        .fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Dominika"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic">
                    „Ako dlhoročná reprezentantka Slovenskej republiky a členka
                    štátneho reprezentačného tímu v spoločenských tancoch som
                    mala možnosť reprezentovať Slovensko na niekoľkých svetových
                    a európskych šampionátoch. Som uvedená do ,,Siene slávy
                    Slovenského zväzu tanečného športu” v kategórií
                    ,,Medzinárodné legendy tanečného športu.” Širšia slovenská
                    verejnosť ma mohla sledovať v televíznej šou Let&apos;s
                    Dance, kde sme sa spolu s hercom Braňom Deákom pretancovali
                    až do finále. V súčasnosti sa venujem profesionálne
                    latinsko-americkým tancom a spolu s Maté Csorbom
                    reprezentujeme Slovenskú republiku.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1">Port De Bras</h3>
              <p className="mb-xlarge">
                PortDeBras je koncept tréningu, ktorý je založený na myšlienke
                posilniť, rehabilitovať a zároveň rozvíjať svoje schopnosti.
                Toto cvičenie vychádza z klasického a moderného tanca, je
                prepojené s prvkami strečingu, posilňovania a posturálnych
                techník (stabilizácia tela). Môžeme ho zaradiť do skupiny
                cvičení tzv. Body&Mind, ktorých cieľom je zosynchronizovať telo
                a myseľ.
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-marian').childImageSharp.fixed
                          .src,
                      },
                      {
                        src: getLector('lektor-marian-2').childImageSharp.fixed
                          .src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-marian').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Marián"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic">
                    „Mám {getAge('1997')} rokov, od detstva som sa venoval
                    spoločenským tancom na profesionálnej úrovni. Od 15 rokov
                    som sa začal venovať aj baletu. Študoval som na
                    konzervatóriu Evy Jaczovej v Bratislave a po skončení som
                    nastúpil do slovenského národného divadla, kde pôsobím
                    dodnes ako člen baletu.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1 mb">Ľudové tance</h3>
              <h4 className="h2">Pre dospelých</h4>
              <p>
                Ľudový tanec je perlou medzi tanečnými štýlmi, lebo vychádza z
                naších ľudových tradícií a zvyklostí. Pri každej možnej
                príležitosti sa spievalo a tancovalo. Naším cieľom je zachovávať
                toto vzácne dedičstvo a spevom a tancom rozveseľovať tých,
                ktorým srdcia bijú pre folklór. Na kurzocch ľudového tanca Vám
                ponúkame znalosti z tanečnej ľudovej motiviky a tanečného
                repertoáru slovenských ľudových tancov.
              </p>

              <h4 className="h2">Pre deti</h4>
              <p className="mb-xlarge">
                Kurzy ľudového tanca pre deti sú vedené formou ľudovej zábavy a
                tanečných hier. Naši najmenší tanečníci si z kurzu odnesú
                znalosti zo základných tanečných ľudových motívov, jednoduchých
                strofických tancov a zoznámia sa aj s tanečnými oblasťami nášho
                malebného Slovenska.
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-viki').childImageSharp.fixed.src,
                      },
                      {
                        src: getLector('lektor-viki-2').childImageSharp.fixed
                          .src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-viki').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Viki"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic">
                    „Mám {getAge('1998')} rokov. Pochádzam z Detvy a od mala sa
                    venujem ľudovému tancu. Tanečné skúsenosti som získala vo
                    folklórnych súboroch (DFS Slniečko, FS Frumani, ale aj v
                    školských inštitúciach (ZUŠ Svetozára Stračinu v Detve,
                    Súkomné Konzervatórium v Nitre). V súčasnosti tancujem v
                    profesionálnom telese SĽUK a popri tom študujem na VŠMU.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection type="beige">
        <Grid>
          <Row>
            <Col xs={12}>
              <h3 className="h1">Aerial Movement</h3>
              <p className="mb-xlarge">
                Aerial Movement Vám ponúkne náhľad do sveta cirkusu, pri ktorom
                objavíte čaro pohybu vo výške. S využitím hodvábnych šálov a
                kruhu môžete pracovať nielen na Vašej fyzickej stránke (funkčná
                sila, flexibilita) ale taktiež na tej kreatívnej a umeleckej.
                Lekcie sú nastavené tak, aby vyhovovali rôznym úrovniam, od
                úplných začiatočníkov až po začínajúcich cirkusových umelcov.
              </p>

              <Row>
                <Col xs={7} xsOffset={2} smOffset={0} sm={5} md={3}>
                  <Avatar
                    images={[
                      {
                        src: getLector('lektor-klaudia').childImageSharp.fixed
                          .src,
                      },
                      {
                        src: getLector('lektor-klaudia-2').childImageSharp.fixed
                          .src,
                      },
                      {
                        src: getLector('lektor-klaudia-3').childImageSharp.fixed
                          .src,
                      },
                    ]}
                    fluid={{
                      ...getLector('lektor-klaudia').childImageSharp.fluid,
                      ...{ aspectRatio: 1 / 1 },
                    }}
                    name="Klaudia"
                  />
                </Col>
                <Col sm={7} md={5}>
                  <p className="text-small text-color-grey text-style-italic">
                    „Mám {getAge('1994')} rokov, od 4 rokov som začala so
                    športovou gymnastikou v Trnave, ktorej som sa venovala do
                    svojich osemnástich rokov. Od roku 2013 sa profesionálne
                    venujem výškovej akrobacii - absolvovala som viac ako 400
                    vystúpení nielen v rámci EÚ ale i vo svete. Okrem výškovej
                    akrobacie sa venujem aj handstandovým číslam, lolipopu, UV
                    šou či ohňovým šou.”
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </PageSection>
    </Layout>
  );
};

export default CreativeMovementStudioPage;

export const CreativeMovementStudioPageQuery = graphql`
  query {
    lektori: allFile(
      filter: {
        name: {
          in: [
            "lektor-marian"
            "lektor-marian-2"
            "lektor-viki"
            "lektor-viki-2"
            "lektor-klaudia"
            "lektor-klaudia-2"
            "lektor-klaudia-3"
            "lektor-dominika"
            "lektor-adrian"
            "lektor-anka"
            "lektor-mate"
            "lektor-dominika-druha"
          ]
        }
      }
    ) {
      edges {
        node {
          name
          childImageSharp {
            fixed(quality: 50, width: 2000) {
              src
            }
            fluid(quality: 50) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`;
